import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaThemeChangePage } from './plaza-theme-change';

@NgModule({
  declarations: [
    PlazaThemeChangePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaThemeChangePage),
    TranslateModule.forChild()
  ],
})
export class PlazaThemeChangePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-theme-change/plaza-theme-change.module.ts